class CollectionBundle extends HTMLElement {
  constructor () {
    super()

    this.bundleContents = []

    this.querySelectorAll('.product-card input[name="updates"]').forEach(input => {
      input.addEventListener('change', () => this.onChangeQty(input))
    })

    this.querySelectorAll('.btn-cb-checkout').forEach(btn => {
      btn.addEventListener('click', () => this.checkout(btn))
    })

    this.summaryCardSticky()
  }

  onChangeQty (input) {
    const item = {
      quantity: Number(input.value),
      product_id: Number(input.dataset.productId),
      variant_id: Number(input.dataset.variantId),
      product_title: input.dataset.productTitle,
      product_image: input.dataset.productImage,
      product_price: Number(input.dataset.productPrice)
    }

    const isInBundle = this.bundleContents.some((elem) => elem.variant_id === item.variant_id)

    if (isInBundle) {
      if (item.quantity === 0) {
        this.bundleContents = this.bundleContents.filter(elem => elem.variant_id !== item.variant_id)
      } else {
        this.bundleContents.map(elem => {
          if (elem.variant_id === item.variant_id) {
            elem.quantity = item.quantity
          }
          return elem
        })
      }
    } else {
      if (item.quantity > 0) {
        this.bundleContents.push(item)
      }
    }

    console.log(this.bundleContents)

    this.buildSummary()
  }

  removeFromBundle (btn) {
    this.bundleContents = this.bundleContents.filter(elem => elem.variant_id !== Number(btn.dataset.variantId))

    this.querySelector(`input[name="updates"][data-variant-id="${btn.dataset.variantId}"]`).value = '0'

    console.log(this.bundleContents)
    this.buildSummary()
  }

  buildSummary () {
    document.querySelectorAll('[data-cb-summary-items-empty]').forEach(elem => {
      if (this.bundleContents.length) {
        elem.setAttribute('hidden', 'hidden')
      } else {
        elem.removeAttribute('hidden')
      }
    })

    document.querySelectorAll('[data-cb-summary-item-list]').forEach(elem => {
      if (this.bundleContents.length) {
        let list = ''

        this.bundleContents.forEach(item => {
          list += `
            <li>
              <div class="row mx-n4 align-items-center">
                <div class="col-3 px-4">
                  <img src="${item.product_image}" class="img-fluid alt="" width="120" height="120">
                </div>
                <div class="col-12 px-4">
                  ${item.product_title} x
                  ${item.quantity}
                </div>
                <div class="col-3 px-4 text-end">
                  <button 
                  class="btn btn-icon" 
                  type="button" 
                  aria-label="Remove" 
                  data-variant-id="${item.variant_id}" 
                  onclick="document.querySelector('.collection-bundle').removeFromBundle(this)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="svg-icon-remove " viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg> 
                  </button>
                </div>
              </di>
            </li>
          `
        })
        elem.innerHTML = list
        elem.removeAttribute('hidden')
      } else {
        elem.innerHTML = ''
        elem.setAttribute('hidden', 'hidden')
      }
    })

    const totalQty = this.bundleContents.reduce((prev, current) => {
      return prev + current.quantity
    }, 0)

    const totalPrice = this.bundleContents.reduce((prev, current) => {
      return prev + current.quantity * current.product_price
    }, 0)

    let discount = 0
    let canCheckout = false

    document.querySelectorAll('[data-cb-summary-tiers]').forEach(list => {
      list.querySelectorAll('li').forEach(elem => {
        if (Number(elem.dataset.qty) <= totalQty) {
          elem.classList.add('active')
          discount = Number(elem.dataset.discount)
          canCheckout = true
        } else {
          elem.classList.remove('active')
        }
      })
    })

    document.querySelectorAll('[data-cb-progress-bar]').forEach(progressBar => {
      let width

      switch (totalQty) {
      case 0: width = 0; break
      case 1: width = 4; break
      case 2: width = 8; break
      case 3: width = 12; break
      case 4: width = 20; break
      case 5: width = 28; break
      case 6: width = 36; break
      case 7: width = 42; break
      case 8: width = 50; break
      case 9: width = 56; break
      case 10: width = 62; break
      case 11: width = 70; break
      default: width = 100; break
      }

      progressBar.querySelector('span').style.width = `${width}%`
    })

    document.querySelectorAll('[data-cb-total]').forEach(elem => {
      if (discount > 0) {
        elem.textContent = window.Shopify.formatMoney(totalPrice)
        elem.removeAttribute('hidden')
      } else {
        elem.setAttribute('hidden', 'hidden')
      }
    })

    document.querySelectorAll('[data-cb-subtotal]').forEach(elem => {
      elem.textContent = window.Shopify.formatMoney(totalPrice * (100 - discount) / 100)
    })

    document.querySelectorAll('.btn-cb-checkout').forEach(btn => {
      btn.disabled = !canCheckout
    })
  }

  summaryCardSticky () {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      const headerGroup = document.querySelector('#header-group.sticky-top')

      const summaryCard = this.querySelector('.cb-summary-card')
      summaryCard.style.top = `${headerGroup.clientHeight + 20}px`
    }
  }

  async checkout (btn) {
    btn.classList.add('loading')
    btn.disabled = true
    btn.setAttribute('aria-busy', 'true')

    const items = this.bundleContents.reduce((accumulator, currentValue) => {
      accumulator.push({
        id: currentValue.variant_id,
        quantity: currentValue.quantity
      })
      return accumulator
    }, [])

    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })

    btn.classList.remove('loading')
    btn.disabled = false
    btn.setAttribute('aria-busy', 'false')

    window.location.href = '/checkout'
  }
}
customElements.define('collection-bundle', CollectionBundle)
